import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { SIZES } from '../../styles/theme'
import config from '../../config'
import kv from '../../images/backdrops/kv.png'
import title from '../../images/backdrops/title.png'
import brand from '../../images/backdrops/entrance-brand.png'
import brandOrganiser from '../../images/backdrops/organiser.png'
import brandSponsor from '../../images/backdrops/sponsor.png'

const Page = styled.div`
  min-height: 100vh;
  height: 100vh;
  background-image: url(${config.assets.register.landscape});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  color: #FFFFFF;
  padding-bottom: 4.5em;
  padding-top: 3em;

  .mobile-show {
    display: none;
  }
  .brand {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    padding-bottom: 3em;
    align-items: center;
    ${SIZES.mobile} {
      height: inherit;
      padding-bottom: 1em;
    }
  }

  
  #message {
    width: 100%;
    color: #10227A;
    margin: 0 auto;
    text-align: center;
    font-weight: 600;
    h5 {
      font-size: 150%;
    }
  }
  ${SIZES.mobile} {
    padding: 1em 0;
    height: 100%;
    background-image: url(${config.assets.register.portrait});
    .mobile-hide {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    img#banner-portrait {
      display: block;
    }
    #message {
      width: 85%;
      h1 {
        font-size: 1.5em;
      }
      h4 {
        font-size: 1.2em;
      }
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
  }
`

export default function PostRegisterPage() {

  return (
    <Page>
      <Row noGutters className="px-4 pt-2 pb-3">
        <Col md={6}>
          <div className="mobile-show">
            <img width="90%" src={title} alt="event-title" className="d-block mx-auto" />
          </div>
          <Row noGutters className="brand px-md-4">
            <Col sm={6} lg={12}>
              <img width="90%" src={kv} alt="event-banner" className="d-block mx-auto" />
            </Col>
            <Col sm={6} lg={12}>
              <div className="mobile-hide">
                <img width="90%" src={brand} alt="event-logo" className="d-block mx-auto" />
              </div>
              <div className="mobile-show mt-3">
                <img width="90%" src={brandOrganiser} alt="event-logo" className="d-block mx-auto" />
                <img width="90%" src={brandSponsor} alt="event-logo" className="d-block mx-auto" />
              </div>
            </Col>
          </Row>
        </Col>

        <Col md={6} className="align-self-center">
          <div className="mobile-hide">
            <img width="80%" src={title} alt="event-title" className="d-block mx-auto" />
          </div>
          <div id="message" className="mt-5">
            <h1>Thank you!</h1>
            <h4>A confirmation email has been sent to you.</h4>
            <h4>Please check you email.</h4>
          </div>
        </Col>
        <div className="mobile-show mb-3 mb-md-5 mt-auto">
          {/* <img width="40%" src={logo} alt="event-logo" className="d-block mx-auto" /> */}
        </div>
      </Row>
    </Page>
  )
}
